import {useLocation, Outlet, Navigate} from "react-router-dom";
import {useIdToken} from "react-firebase-hooks/auth";
import {auth} from "@/features/auth/firebase.js";
import {FullScreenLoader} from "@/components/FullScreenLoader.jsx";
import {useDispatch} from "react-redux";
import {setUser} from "@/features/auth/state.js";
import {useEffect} from "react";

export function AuthBase() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [user, loading, error] = useIdToken(auth);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (loading) return;
    const userData = user === null ? null : { accessToken: user.accessToken };
    dispatch(setUser(userData));
  }, [user, loading, dispatch]);

  if (loading) return <FullScreenLoader />;

  // TODO: Make this a bit more user friendly
  if (error) return <div>Error: {error}</div>;

  if (location.pathname === '/') {
    const path = (user) ? '/default-household' : '/sign-in';
    return <Navigate to={path} replace={true} />;
  }

  return <Outlet />;
}
